import React from 'react';
import { Star, BadgeMinus } from 'lucide-react';

export default function LicenseTypeIcon({ type }) {
  if (type === 'PRO') {
    return <Star color="#ffa600" title="Pro" style={{ verticalAlign: 'middle' }} />;
  }
  return <BadgeMinus color="#64748b" title="Básica" style={{ verticalAlign: 'middle' }} />;
}
